import React from 'react'

const ViewSuppliers = () => {
  return (
    <div>ViewSuppliers</div>
  )
}

export default ViewSuppliers